import * as Yup from 'yup';

export const validationSchemaForm = Yup.object().shape({
    itemformCity: Yup
      .string()
      .required("Campo requerido"),
    dateYear: Yup
      .string()
      .required("Campo requerido"),
    dateMonth: Yup
      .string()
      .required("Campo requerido"),
    termsOfService: Yup
      .boolean()
      .required("Debe aceptar los términos y condiciones para continuar")
      .oneOf([true], "Debe aceptar los términos y condiciones para continuar"),
    resolution3374Document: Yup.mixed()
      .nullable()
      .required("Debe cargar un archivo"),
    codeDane: Yup
      .string()
      .required("Campo requerido"),
    emailUser: Yup
      .string()
      .email("Ingrese un formato de correo valido (ejemplo@xyz.com)")
      .required("Campo requerido"),
    confirmEmail: Yup
      .string()
      .email("Debe ser igual al correo ingresado")
      .oneOf([Yup.ref("emailUser"), null], "Los correos no coinciden")
      .required("Campo requerido"),
    names: Yup
      .string()
      .required("Campo requerido"),
    phone: Yup
      .string()
      .matches(/^[0-9]+$/, "El teléfono debe contener solo números")
      .min(10, "El teléfono debe tener al menos 10 dígitos")
      .required("Campo requerido"),
    role: Yup
      .string()
      .required("Campo requerido"),
  });